<div
  @toggleTooltip
  [style.margin.px]="additionalOffset"
  [style.marginBottom.px]="mobileBottomOffset || additionalOffset"
  class="tooltip santa-typo-additional {{ customOffsetClass || '' }}"
  [ngClass]="tooltipPositionConfig[tooltipPosition]"
>
  <ng-container *ngIf="content">
    <ng-container *polymorpheusOutlet="content as item; context: assertedContext">
      <p *ngIf="item" [class.santa-whitespace-nowrap]="!wrapText" class="santa-m-0 santa-typo-additional santa-text-black-100">
        {{ item }}
      </p>
    </ng-container>
  </ng-container>
</div>
